import { render, staticRenderFns } from "./DashboardCourseTotalList.vue?vue&type=template&id=ae905f4a&"
import script from "./DashboardCourseTotalList.vue?vue&type=script&lang=js&"
export * from "./DashboardCourseTotalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports